import { faker } from '@faker-js/faker';

import flags from '@/lib/flags.json';

interface Flag {
  title: string;
  enabled: boolean;
  description: string;
  variants: string[] | boolean[];
}

type Config = Record<string, Flag>;

export function getConfig(): Config {
  return flags;
}

export function decideAll(id: string): Record<string, string | boolean> {
  const features = getConfig();

  const userFlags: Record<string, boolean> = {};
  Object.entries(features).forEach((flag) => {
    const [name, config] = flag;
    userFlags[name] = decide(id, config);
  });

  return userFlags;
}

export function calculateCohort(
  // biome-ignore lint/suspicious/noExplicitAny: todo
  features: Record<string, any>,
): [string, number] {
  try {
    let i = 1;
    const seed = Object.entries(features)
      .map((features) => {
        const [_, value] = features;
        const encoded = `${value}`.charCodeAt(0);
        return [i++, encoded]; // [1,96],
      })
      .sort()
      .join('')
      .replaceAll(',', '');

    const numericSeed = Number.parseInt(seed);
    faker.seed(numericSeed); // this should give a repeatable value for a given seed

    const code = [faker.animal.petName(), faker.book.title()]
      .join('-')
      .replaceAll(' ', '-')
      .toLocaleLowerCase();

    return [code, numericSeed];
  } catch (e) {
    console.warn('could not put in cohort', e);
  }

  return ['default', 0];
}

// biome-ignore lint/suspicious/noExplicitAny: todo
export function decide(id: string, config: any) {
  const { enabled, variants } = config;
  if (enabled && variants) {
    const numVariants = variants.length;
    const hash = id;

    /**
     * This bucketing algorithm is predicated on our randomUUID being fair
     * which I think is acceptable based on testing. The buckets are NOT
     * and will never be completely aligned, but simple a/b bucketing works.
     */
    const numericHash = Number.parseInt(hash.split('-').reverse()[0], 16); // uuidv7 is sequential, which may make the first stanza too similar?

    // https://github.com/fetlife/rollout/blob/master/lib/rollout/feature.rb#L99
    const index = ((numericHash % 2 ** 32) + numVariants) % numVariants;
    return variants[index];
  }

  return false;
}
